import { jsx } from 'react/jsx-runtime';
import { clsx } from '@flex-design-system/ve-presets';
import { CommandGroup } from 'cmdk';
import { forwardRef, useId } from 'react';
import { selectGroup } from '../../../shared/styles/group.vanilla.mjs';
import { SingleSelectGroupContextProvider } from '../../contexts/group-context.mjs';

const SingleSelectGroup = forwardRef(({ className: classNameFromProps, title, ...props }, forwardedRef) => {
  const groupId = useId();
  const className = clsx(selectGroup, classNameFromProps);
  return /* @__PURE__ */ jsx(SingleSelectGroupContextProvider, { id: groupId, children: /* @__PURE__ */ jsx(
    CommandGroup,
    {
      "aria-labelledby": groupId,
      "data-scope": "single-select",
      "data-part": "group",
      className,
      heading: title,
      ref: forwardedRef,
      ...props
    }
  ) });
});

export { SingleSelectGroup as SelectGroup };
//# sourceMappingURL=Group.mjs.map
